// extracted by mini-css-extract-plugin
export var center = "_5j-2";
export var clickableRow = "_5j-5";
export var expandedRow = "_5j-7";
export var hoverable = "_5j-4";
export var left = "_5j-1";
export var right = "_5j-3";
export var row = "_5j-0";
export var selectedRow = "_5j-6";
export var summaryRow = "_5j-8";